export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kunstgalerie01-de.057a719b.png";